import { useEffect, useRef, useState } from 'react'

// Round tick values (1, 2, 5 × 10^n steps) covering min..max.
export function niceTicks(min, max, count = 4) {
  if (!(max > min)) return [min]
  const raw = (max - min) / count
  const mag = 10 ** Math.floor(Math.log10(raw))
  const step = [1, 2, 5, 10].map((m) => m * mag).find((s) => s >= raw)
  const ticks = []
  for (let t = Math.ceil(min / step) * step; t <= max + 1e-9; t += step) ticks.push(t)
  return ticks
}

// [ref, width]: the width of the element the ref is attached to, following resizes.
export function useWidth(initial = 600, min = 280) {
  const ref = useRef(null)
  const [width, setWidth] = useState(initial)
  useEffect(() => {
    const el = ref.current
    if (!el) return undefined
    const observer = new ResizeObserver(([entry]) => setWidth(Math.max(min, entry.contentRect.width)))
    observer.observe(el)
    return () => observer.disconnect()
  }, [min])
  return [ref, width]
}
